import React from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { BiHome } from 'react-icons/bi';

import bg from 'assets/images/background.svg';
import Button from 'partial/components/Button';
// import logo from 'assets/images/logo-horizontal.svg';
// import make from 'assets/images/powered-by.svg';
import IconVerifyEmail from 'assets/images/icons/icon-verify-email.svg';
import Version from 'partial/components/Version';
import { SolidLogo } from 'modules/common/components/AppIconLogo';

import SignUpForm from '../forms/SignUpForm';
import { useResendEmail } from '../hooks';

function SignUpSuccess({ data }) {
  const history = useHistory();
  const [isLoading, resendEmail] = useResendEmail(
    data?.uuid,
    (res) => {
      history.push({
        pathname: `/email-activation/resend/${res?.data?.uuid}`,
        state: { email_address: res?.data?.receiver || '' },
      });
    },
    () => {}
  );

  const handleResendVerification = () => {
    resendEmail();
  };

  return (
    <div className="space-y-3">
      <div className="text-center space-y-2">
        <div className="flex justify-center">
          <img
            src={IconVerifyEmail}
            alt="icon-verify-email"
            className="h-40 w-40"
          />
        </div>
        <div className="text-lg font-semibold">Verify Your email</div>
        <div className="font-light space-y-1">
          <p>
            We have sent an email verification link to{' '}
            <span className="font-semibold text-gray-600">
              {data?.email_address || 'you email'}
            </span>{' '}
            to verify your account.
          </p>
        </div>
      </div>
      <hr />
      <div className="flex items-center justify-center text-center pt-2 space-x-1">
        <p>Didn&apos;t get the email?</p>
        <Button
          size="sm"
          transparent
          className="px-0 text-gray-500"
          onClick={handleResendVerification}
          disabled={isLoading}
        >
          Resend
        </Button>
      </div>
    </div>
  );
}

SignUpSuccess.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
};

function SignUp() {
  const history = useHistory();
  const [isSuccess, setIsSuccess] = React.useState(null);
  return (
    <div className="flex flex-col flex-grow bg-gradient-to-t from-primary-700 to-primary-800">
      <div
        className="h-full flex flex-col bg-no-repeat bg-center bg-cover relative"
        style={{ backgroundImage: `url(${bg})` }}
      >
        <div className="absolute top-5 left-5 uppercase">
          {isSuccess && (
            <Button
              outlineLight
              icon={BiHome}
              onClick={() => history.push('/')}
            >
              Back to homepage
            </Button>
          )}
        </div>
        <div className="w-full max-w-xl m-auto ">
          <div className="mt-16 mb-12 w-full rounded-none sm:rounded-3xl z-20 relative">
            {isSuccess ? (
              <div className="flex justify-center mb-6 h-40 relative">
                <SolidLogo className="h-40" />
                <p className="absolute bottom-9 ml-20 text-xs text-white whitespace-nowrap">
                  BILLER PORTAL
                </p>
              </div>
            ) : null}

            <div className="p-10 rounded-none sm:rounded-3xl bg-white shadow-primary-xl">
              {isSuccess ? (
                <SignUpSuccess data={isSuccess} />
              ) : (
                <SignUpForm onSuccess={(res) => setIsSuccess(res)} />
              )}
            </div>
            <div className="text-xs font-light text-center text-white mt-7">
              &copy; 2021 DST Biller Portal <Version />
            </div>
          </div>
        </div>
        {/* <div className="fixed bottom-7 w-full text-center">
          <p className="text-gray-400 text-xs">Developed by</p>
          <img src={make} className="h-6 mx-auto mb-12" alt="Brand" />
        </div> */}
      </div>
    </div>
  );
}

SignUp.propTypes = {};

export default SignUp;
